import { ColorOptions, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { DropdownOptimised } from '../../components/DropdownNew'

const categoryData = [
  { id: 1, value: 'B2BGrocery' },
  { id: 2, value: 'BillPay' },
  { id: 3, value: 'Education' },
  { id: 4, value: 'Loadmoney' },
  { id: 5, value: 'OtherEcommCategory1' },
  { id: 6, value: 'OtherEcommCategory1' },
]

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

const formData: any = (
  onSubmit: (values: string) => void,
  isEditble: boolean,
  message: string,
  packageCategoryList: any[],
) => [
  {
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'group',
            ComponentName: TextInputNew,
            label: 'Group Name*',
            placeholder: 'Group Name',
            editable: isEditble,
            validationSchema: required,
            ...textinputStyle,
          },
          {
            fieldName: 'category',
            ComponentName: DropdownOptimised,
            title: 'Category',
            label: 'Category*',
            validationSchema: required,
            data: packageCategoryList ?? categoryData,
            showSearch: true,
            maxHeight: 400,
            ...textinputStyle,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      onSubmit(values)
      return 'end'
    },
    actionTitle: 'Submit',
  },
]

export { formData }
